const isCompanyRegionSelectionEnabled = (flagValue = import.meta.env.VITE_GRAVITY_COMPANY_REGION_SELECTION_ENABLED) => flagValue === 'true';

export default isCompanyRegionSelectionEnabled;
